import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import es from '@angular/common/locales/es-CO';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { Device } from '@ionic-native/device/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { File } from '@ionic-native/file/ngx';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
// import { OneSignal } from '@ionic-native/onesignal/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { UpdatePasswordPageModule } from '@modals/auth/login/update-password/update-password.module';
import { ModalsModule } from '@modals/modals.module';
import { ChangePasswordPageModule } from '@modals/profile/change-password/change-password.module';
import { SampleDetailsPageModule } from '@modals/request/sample-details/sample-details.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { QuicklinkModule } from 'ngx-quicklink';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { AppComponent } from 'src/app/app.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { JwtInterceptor } from 'src/app/helpers';
import { environment } from 'src/environments/environment';
import * as Sentry from '@sentry/angular';

import { ErrorInterceptor } from './helpers/error.interceptor';
import { TrackingInterceptor } from './helpers/tracking.interceptor';
import { SentryErrorHandler } from './helpers/sentry-error-handler';

registerLocaleData(es)

// Inicialización de Sentry solo en producción
if (environment.production) {
  Sentry.init({
    dsn: environment.sentry,
    environment: 'production',
    tracesSampleRate: 1.0
  });

  Sentry.setContext('character', {
    version: environment.version,
  });
}

export function createTranslatedLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json')
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    QuicklinkModule,
    IonicStorageModule.forRoot(),
    BrowserAnimationsModule,
    ComponentsModule,
    ModalsModule,
    ChangePasswordPageModule,
    UpdatePasswordPageModule,
    SampleDetailsPageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslatedLoader,
        deps: [HttpClient]
      }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: ErrorHandler, useClass: environment.production ? SentryErrorHandler : ErrorHandler },
    Device,
    ScreenOrientation,
    // OneSignal,
    FingerprintAIO,
    File,
    FileOpener,
    FileTransfer,
    AndroidPermissions,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TrackingInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  public r_width: number = window.innerWidth
}
